<template>
  <el-aside id="aside" class="aside" :width="`${isCollapse ? '80' : '210'}px`">
    <div class="top_logo">
      <img class="logo_img" :src="user.companyLogo || require('@/assets/images/m_logo.png')" alt="">
      <div class="logo_text">
        <span>回收商后台-{{user.merchantName}}</span>
        <div :class="userOnline?'user_on_line':'user_on_unline'">
          <span>{{userOnline?'审单上线':'审单下线'}}</span>
        </div>
      </div>
      <el-menu
        style="width: 100%;"
        :collapse="isCollapse"
        :default-active="$route.path"
        :default-openeds="defaultOpeneds"
        :unique-opened="true"
        :background-color="isCollapse?'#FFFFFF':'rgba(255, 255, 255, 0)'"
        text-color="#081A56"
        active-text-color="#2D81FF"
      >
        <div v-for="tab in routersList" :key="tab.path">
          <el-menu-item
            v-if="tab.type === 'menu-item'"
            :index="tab.path"
            @click="tab.method || routerLinks(tab.path)"
          >
            <!-- <img class="mr-10 menu_icon" :src="bingActiveIcon(tab.menuIcon)"  v-if="$route.path == tab.path"  /> -->
            <img class="mr-10 menu_icon" :src="bingIcon(tab.menuIcon)" alt="" srcset="" />
            <span slot="title">{{ tab.name }}</span>
          </el-menu-item>
  
          <el-submenu v-if="tab.type === 'submenu'" :index="tab.path">
            <template slot="title">
              <img class="mr-10 menu_icon" :src="bingIcon(tab.menuIcon)" alt="" srcset="" />
              <span v-show="!isCollapse" slot="title">{{ tab.name }}</span>
            </template>
            <div v-for="item in tab.children" :key="item.path">
              <el-menu-item
                v-if="!item.method"
                :index="item.path"
                @click="routerLinks(item.path)"
              >
                {{ item.name }}
              </el-menu-item>
              <!--使用三目运算不能正常触发method，改成if-->
              <el-menu-item v-else :index="item.path" @click="item.method">
                {{ item.name }}
              </el-menu-item>
            </div>
          </el-submenu>
        </div>
      </el-menu>
    </div>
  </el-aside>
</template>

<script>
import _api from "@/utils/request";
export default {
  name: "Aside",
  data() {
    return {
      user: {},
      /*
       * type: 'menu-item'(单个菜单)、'submenu'(菜单组)
       * */
      routersList: [
        // {
        //   path: "/dashboard",
        //   type: "menu-item",
        //   icon: "el-icon-s-home",
        //   name: "首页",
        // },
        // {
        //   type: "submenu",
        //   path: "/storeManage",
        //   icon: "el-icon-picture-outline-round",
        //   name: "回收商管理",
        //   children: [
        //     {
        //       path: "/storeManage/index",
        //       name: "回收商列表",
        //     }
        //   ],
        // },
        // {
        //   type: "submenu",
        //   path: "/merchant",
        //   icon: "el-icon-picture-outline-round",
        //   name: "第三方回收商",
        //   children: [
        //     {
        //       path: "/merchant/list",
        //       name: "商家列表",
        //     },
        //   ],
        // },
        // {
        //   type: "submenu",
        //   path: "/RecallOrder",
        //   icon: "el-icon-picture-outline-round",
        //   name: "订单管理",
        //   children: [
        //     {
        //       path: "/RecallOrder/index",
        //       name: "订单列表",
        //     },
        //     {
        //       path: "/RecallOrder/spreadOrder/index",
        //       name: "差价订单",
        //     }
        //   ],
        // },
        // {
        //   type: "submenu",
        //   path: "/systemManage",
        //   icon: "el-icon-picture-outline-round",
        //   name: "系统管理",
        //   children: [
        //     {
        //       path: "/systemManage/RolePurview",
        //       name: "角色权限",
        //     },
        //     {
        //       path: "/systemManage/StaffManage",
        //       name: "职员管理",
        //     }
        //   ],
        // },
      ],
      defaultActive: this.activeTab,
      // 默认打开的tabs: ['/feature']
      defaultOpeneds: [],
    };
  },
  created() {
    this.user=JSON.parse(localStorage.getItem('user')) || {}
    

    this.getMenuList();
  },
  mounted() {
    const path = this.$route.path;
    console.log(path);
    if (path.indexOf("/feature/TabsView") === -1) {
      this.defaultActive = path;
    } else {
      this.defaultActive = "/feature/TabsView";
    }
  },
  computed: {
    isCollapse() {
      return this.$store.state.tagsView.isCollapse;
    },
    userOnline() {
      return this.$store.state.tagsView.userOnline;
    },
  },
  methods: {
    bingIcon(icon) {
      icon = icon || "sytb";
      let reg = icon.indexOf('http')
      return reg>=0?icon:require(`@/assets/menu/${icon}.png`);
    },
    bingActiveIcon(icon) {
      icon = icon || "sytb";
      let reg = icon.indexOf('http')
      return reg>=0?icon:require(`@/assets/menu/${icon}_hover.png`);
    },
    routerLinks(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    getMenuList() {
      _api.getMenuList().then((res) => {
        this.$store.commit('tagsView/MENU_LIST', res.data)
        res.data.forEach(item => {
          item.name = item.menuName
          item.path = item.menuUrl
          // if(item.menuName == '首页'){
          //   item.icon = 'sytb'
          // }else{
          //   item.icon = 'default'
          // }
          if(item.children && item.children.length != 0){
            item.type = 'submenu'
            item.children.forEach(ele => {
              ele.name = ele.menuName
              ele.path = ele.menuUrl
            })
          }else{
            item.type = 'menu-item'
          }
        });
        this.routersList = res.data
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.aside {
  position: relative;
  z-index: 10;
  // background: #273655;
  border-radius: 0px 30px 30px 0px;
  transition: width 0.3s;
  background-color: #fff;
  box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.1);
  .top_logo{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 30px;
    box-sizing: border-box;
    // width: 210px;
    height: 100%;
    background-image: url("../../../assets/images/logo_bg.png");
    background-size: 210px 260px;
    background-repeat: no-repeat;
    .logo_img{
      width: 38px;
      height: 38px;
      margin-bottom: 13px;
    }
    .logo_text{
      position: relative;
      font-weight: bold;
      font-size: 16px;
      color: #081A56;
      text-align: center;
      margin-bottom: 30px;
    }
  }
  .user_on_line{
    position: absolute;
    top: -20px;
    right: 5px;
    width: 52px;
    height: 20px;
    background: linear-gradient( 142deg, #FFCA79 0%, #FFA032 100%);
    border-radius: 11px 13px 13px 0px;
    border: 1px solid #FFFFFF;
    font-weight: 500;
    font-size: 11px;
    color: #FFFFFF;
    line-height: 20px;
    text-align: center;
  }
  .user_on_unline{
    position: absolute;
    top: -20px;
    right: 5px;
    width: 52px;
    height: 20px;
    background: linear-gradient( 142deg, #FF9E79 0%, #FF6532 100%);
    border-radius: 11px 13px 13px 0px;
    border: 1px solid #FFFFFF;
    font-weight: 500;
    font-size: 11px;
    color: #FFFFFF;
    line-height: 20px;
    text-align: center;
  }
}
.mr-10{
  margin-right: 10px;
}
.menu_icon{
  width: 24px;
  height: 24px;
}
</style>
